import api from "../Api";
import { ApiPath } from "../ApiPath";
import { ResponseModel } from "../model/response/ResponseModel";
import {
  CompanyInfoModel,
  CompanyProduct,
} from "../model/response/CompanyInfoModel";
import { useUserContext } from "../../context/UserContext";
import { LanguageModel } from "../model/response/LanguageModel";
import { OnlineMenuModel } from "../model/response/OnlineMenuResponseModel";
import { HomeModel } from "../model/response/HomeModel";
const OnlineMenuService = () => {
  const {
    setCurrentOnlineMenu,
    setCurrentLanguagesList,
    setCurrentCompanyInfo,
    setCurrentHomeData,
    setCurrentCompanyProduct,
  } = useUserContext();
  const subDomain = window.location.href.includes("localhost:")
    ? "demo"
    : window.location.href
        .replaceAll("https://", "")
        .replaceAll("http://", "")
        .split(".")[0];
  const subDomainParams = new URLSearchParams({
    title: subDomain,
  });

  function getCompanyProduct() {
    const err = { error: true } as ResponseModel<CompanyProduct[]>;
    return api()
      .get<ResponseModel<CompanyProduct[]>>(
        `${ApiPath.getCompanyProductsWeb}?${subDomainParams}`
      )
      .then((value) => {
        if (value.data.statusCode === 1000) {
          setCurrentCompanyProduct(value.data.responseModel);
          return value.data;
        } else {
          return err;
        }
      })
      .catch(() => {
        return err;
      });
  }
  function getHomeRequestResponse() {
    const err = { error: true } as ResponseModel<HomeModel>;
    return api()
      .get<ResponseModel<HomeModel>>(
        `${ApiPath.getOnlineMenuHomeData}?${subDomainParams}`
      )
      .then((value) => {
        if (value.data.statusCode === 1000) {
          setCurrentHomeData(value.data.responseModel);
          return value.data;
        } else {
          return err;
        }
      })
      .catch(() => {
        return err;
      });
  }
  function getOnlineMenuLanguages() {
    const err = { error: true } as ResponseModel<LanguageModel[]>;
    return api()
      .get<ResponseModel<LanguageModel[]>>(
        `${ApiPath.getOnlineMenuLanguages}?${subDomainParams}`,
        {}
      )
      .then((value) => {
        if (value.data.statusCode === 1000) {
          setCurrentLanguagesList(value.data.responseModel);
          return value.data;
        } else {
          return err;
        }
      })
      .catch(() => {
        return err;
      });
  }
  function getOnlineMenuCompanyInformation() {
    const err = { error: true } as ResponseModel<CompanyInfoModel>;
    return api()
      .get<ResponseModel<CompanyInfoModel>>(
        `${ApiPath.getOnlineMenuCompany}?${subDomainParams}`
      )
      .then((value) => {
        if (value.data.statusCode === 1000) {
          setCurrentCompanyInfo(value.data.responseModel);
          return value.data;
        } else {
          return err;
        }
      })
      .catch(() => {
        return err;
      });
  }
  function getOnlineMenu() {
    const err = { error: true } as ResponseModel<OnlineMenuModel>;
    return api()
      .get<ResponseModel<OnlineMenuModel>>(
        `${ApiPath.getOnlineMenuWeb}?${subDomainParams}`
      )
      .then((value) => {
        if (value.data.statusCode === 1000) {
          setCurrentOnlineMenu(value.data.responseModel);
          return value.data;
        } else {
          return err;
        }
      })
      .catch(() => {
        return err;
      });
  }

  return {
    getOnlineMenu,
    getOnlineMenuCompanyInformation,
    getOnlineMenuLanguages,
    getHomeRequestResponse,
    getCompanyProduct,
  };
};
export default OnlineMenuService;
